<template>
  <b-col class="p-0">
    <b-row no-gutters class="align-items-start">
      <!-- Slot de Erros -->
      <b-col cols="12" class="p-0 mb-3" v-if="$slots.errors">
        <slot name="errors"></slot>
      </b-col>

      <!-- Grid de Cards de Resumo (Ocupando 12 colunas) -->
      <b-row class="w-100 m-0">
        <!-- Qtde. Notas -->
        <b-col cols="12" sm="6" md="3" class="px-1 mb-1">
          <div class="summary-card shadow-sm w-100">
            <div class="summary-header">Qtde. Notas</div>
            <div class="summary-divider"></div>
            <div class="summary-value text-primary">{{ form.qtde_nfs }}</div>
          </div>
        </b-col>

        <!-- Vlr. Total NFs -->
        <b-col cols="12" sm="6" md="3" class="px-1 mb-1">
          <div class="summary-card shadow-sm w-100">
            <div class="summary-header">Vlr. Total NFs</div>
            <div class="summary-divider"></div>
            <div class="summary-value text-success">{{ formatMoney(form.vlr_total_nfs) }}</div>
          </div>
        </b-col>

        <!-- Peso Total Bruto -->
        <b-col cols="12" sm="6" md="3" class="px-1 mb-1">
          <div class="summary-card shadow-sm w-100">
            <div class="summary-header">Peso Total (kg)</div>
            <div class="summary-divider"></div>
            <div class="summary-value">{{ formatNumber(form.vlr_total_peso_bruto) }}</div>
          </div>
        </b-col>

        <!-- Volume Total -->
        <b-col cols="12" sm="6" md="3" class="px-1 mb-1">
          <div class="summary-card shadow-sm w-100">
            <div class="summary-header">Volume Total</div>
            <div class="summary-divider"></div>
            <div class="summary-value">{{ form.vlr_total_volume }}</div>
          </div>
        </b-col>
      </b-row>
    </b-row>
  </b-col>
</template>

<script>
import accounting from "accounting";

export default {
  name: "SummaryHeader",
  props: {
    form: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      default: 'R$'
    }
  },
  methods: {
    formatMoney(value) {
      return accounting.formatMoney(value || 0, "R$ ", 2, ".", ",");
    },
    formatNumber(value) {
      return accounting.formatNumber(value || 0, 2, ".", ",");
    }
  }
};
</script>

<style scoped>
.summary-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 16px 20px;
    height: 100%;
    transition: all 0.3s ease;
}

.summary-card:hover {
    border-color: #d1d5db;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05) !important;
}

.summary-header {
    font-size: 0.8rem;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
    margin-bottom: 8px;
}

.summary-divider {
    height: 1px;
    background-color: #f3f4f6;
    margin-bottom: 12px;
}

.summary-value {
    font-size: 1.3rem;
    font-weight: 800;
    color: #111827;
}

/* Adicionando cores sutis para destacar KPIs */
.text-primary {
    color: #2563eb !important;
}
.text-success {
    color: #059669 !important;
}
</style>
